import Vue from 'vue'

const Order = class {
  constructor({
    status,
    orderId,
    shopName,
    orderName,
    orderAmount,
    arriveDateTime,
    createdDateTime,
    member,
    paymentAmount,

    reservation = false,
    reservationDateFrom, // yyyy-MM-dd HH:mm:ss
    reservationDateTo, // yyyy-MM-dd HH:mm:ss

    orderSummaryId,
    createdDate
  }) {
    this.status = status // "PRODUCT_PREPARATION",
    this.orderId = orderId // 11697,
    this.shopName = shopName // "배민마켓 송파점",
    this.orderName = orderName // "흑당 밀크티 찐한 롤링팡",
    this.orderAmount = orderAmount // 54000,
    this.arriveDateTime = arriveDateTime // "2019-10-22T11:29:00",
    this.createdDateTime = createdDateTime // "2019-10-22T10:59:00",
    this.paymentAmount = paymentAmount
    this.member = member // true

    this.reservation = reservation // true,
    this.reservationDateFrom = reservationDateFrom // "yyyy-MM-dd HH:mm:ss",
    this.reservationDateTo = reservationDateTo // "yyyy-MM-dd HH:mm:ss",

    this.orderSummaryId = orderSummaryId // 2706,
    this.createdDate = createdDate // "2019-08-07T12:15:04"
  }

  get isNotInProgress() {
    return [ 'CANCELLED', 'COMPLETED' ].includes(this.status)
  }

  get isCancelled() {
    return [ 'CANCELLED' ].includes(this.status)
  }

  get isReservationAndWaiting() {
    return this.reservation && [ 'PAYMENTED' ].includes(this.status)
  }

  get isDisplayDeliveryTitle() {
    return this.isNotInProgress ? true : !!this.arriveDateTime
  }

  get displayStatus() {
    if (this.isNotInProgress) {
      return '완료'
    }

    if (this.isReservationAndWaiting) {
      return '예약 배달'
    }

    return '진행중'
  }

  get displayDeliveryTitle() {
    if (this.isNotInProgress) {
      return this.getNotInProgressDisplayDeliveryTitle()
    }

    if (this.isReservationAndWaiting) {
      return this.getReservationDisplayDeliveryTitle()
    }

    return this.getDefaultDisplayDeliveryTitle()
  }

  get displayDeliveryProgress() {
    // TODO check src/components/my/order/DeliveringItem.vue:48
    // const baseClass = 'progress-circle'
    // switch (this.status) {
    //   case 'ORDERED':
    //     return baseClass + '-25'
    //   case 'PRODUCT_PREPARATION':
    //     return baseClass + '-50'
    //   case 'DELIVERING':
    //     return baseClass + '-75'
    //   default:
    //     return baseClass + '-none'
    // }

    // TODO 레이아웃 필요한 데이터 형태로 반환 필요
    // 우선 0, 25, 50, 70 으로 반환
    // TODO 예약 배달 단계도 포함
    switch (this.status) {
      case 'ORDERED':
        return 25
      case 'PRODUCT_PREPARATION':
        return 50
      case 'DELIVERING':
        return 75
      default:
        return 0
    }
  }

  get toShowOrderBadgeParam() {
    const parsedCreatedDateTime = Vue.time(new Date(this.createdDateTime)).add(3, 'hours').locale('ko').format('x')

    return `{"${this.orderId}":${parsedCreatedDateTime}}`
  }

  getNotInProgressDisplayDeliveryTitle() {
    const nowTime = Vue.time(new Date())

    const time = Vue.time(this.createdDate).locale('ko')
    const dayGap = Math.floor(Vue.time.duration(nowTime.diff(time)).asDays())
    const timeGap = Math.floor(Vue.time.duration(nowTime.diff(time)).asHours())

    if (dayGap >= 7) {
      return `${time.format('M/D')} (${time.format('ddd')})`
    } else if (dayGap >= 1) {
      return `${dayGap}일 전`
    } else if (timeGap >= 1) {
      return `${timeGap}시간 전`
    } else if (timeGap === 0) {
      return '방금'
    } else {
      return `${time.format('M/D')} (${time.format('ddd')})`
    }
  }

  getReservationDisplayDeliveryTitle() {
    const from = Vue.time(this.reservationDateFrom, 'YYYY-MM-DD HH:mm:ss').locale('ko').format('LT') // `오후 9:00`

    const to = Vue.time(this.reservationDateTo, 'YYYY-MM-DD HH:mm:ss').locale('ko').format('h:mm') // `9:30`

    return `${from} ~ ${to} 배달예약`
  }

  getDefaultDisplayDeliveryTitle() {
    const arriveDateTime = Vue.time(this.arriveDateTime).locale('ko').format('LT')

    return `${arriveDateTime} 도착예정`
  }
}

export default null

export const ofOrder = (params = {}) => new Order(params)
